<template>
    <div v-if="firstRendered">
        <div class="filter-condition box-shadow-small border-radius">
            <div class="search-box">
                <el-button class="search-hd" type="primary" icon="el-icon-search" @click="searchKeyword(keyword)"></el-button>
                <div class="search-bd">
                    <search-bar :ajaxSearch="false" v-model="keyword" @enter-key="searchKeyword" @select="searchKeyword"
                                placeholder="请输入职位、姓名、手机号、邮箱进行搜索"></search-bar>
                </div>
            </div>
            <filter-panel @params-change="getParams" ref="condition">
                <filter-panel-item v-for="(item, index) in filterConf" :label="item.label" :mode="item.mode"
                                   :name="item.name" :data="item.data" :key="index"
                                   :initValue="item.value"></filter-panel-item>
            </filter-panel>
        </div>
        <div class="filter-result background-white box-shadow-small border-radius">
            <div class="filter-result-header mt-15 clearfix">
                <el-row type="flex" justify="space-between">
                    <el-col :span="12">
                    </el-col>
                    <el-col :span="12">
                        <el-row v-if="lists.length" type="flex" justify="end">
                            <el-button icon="el-icon-my-queding color-success" type="success" :plain="true"
                                       @click="changeStatus(idStr,'010')">加入专场
                            </el-button>
                            <el-button icon="el-icon-my-guanbi color-danger" type="danger" :plain="true"
                                       @click="changeStatus(idStr,'002')">移出专场
                            </el-button>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div v-loading="partialLoading">
                <empty-tip :show="!lists.length"></empty-tip>
                <div class="table-list mt-20">
                    <el-table v-if="lists.length"
                              :data="lists"
                              @selection-change="handleSelectionChange">
                        <el-table-column
                                type="selection"
                                align="center"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                label="职位编号"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                <router-link class="name-txt" target="_blank"
                                             :to="`/resume/detail/${scope.row.id}/${getPhase(scope.row.status)}`">
                                    {{ scope.row.resumeForm.name }}
                                    <i style="transform: scale(.7)" :class="{'el-icon-my-nan': scope.row.resumeForm.gender === 1, 'el-icon-my-nv color-danger': scope.row.resumeForm.gender === 2}"></i>
                                </router-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="resumeForm.mobilePhone"
                                label="职位名称"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                        </el-table-column>
                        <el-table-column
                                label="工作地点"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.positionForm.name }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="招聘人数"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.resumeForm.workYears || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="招聘部门"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeForm.resumeSource)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="审核时间"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.resumeForm.gameExperience }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="跟进人"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{getSelectMapText('WB_FLOW_STATUS', scope.row.status)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="状态"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{getSelectMapText('WB_FLOW_STATUS', scope.row.status)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                align="center"
                                class-name="no-wrap"
                                min-width="100">
                            <template slot-scope="scope">
                                <el-button type="text" @click="recommendResume(scope.row)">移出</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination
                        v-if="lists.length"
                        class="text-center mt-20 mb-20"
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="pagination.pageIndex"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.recordCounts">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import QueryListExtend from 'components/queryListExtend'
    import positionMixin from './positionMixin'

    export default {
        'extends': QueryListExtend,
        'mixins': [positionMixin],
        data () {
            return {
                fetchUrl: '/resume/list.api',
                filterConf: [{
                    filter: 'WB_RESUME_STATUS_0',
                    label: '简历状态',
                    data: [],
                    name: 'statusSearch'
                }, {
                    filter: 'WB_RESUME_SOURCE',
                    label: '简历来源',
                    data: [],
                    name: 'resumeResumeSourceSearch'
                }],
                searchData: {
                    searchWord: null
                }
            }
        },
        methods: {
            addResume () {
                this.$refs.addResumeDialog.show()
            },
            fetchCallback (res) {
                console.log('resumeList:', res)
            },
            recommendResume (item) {
                this.$refs.recommendResumeDialog.show(item)
            }
        },
        components: {}
    }
</script>
<style type="text/css" lang="scss">

</style>


// WEBPACK FOOTER //
// recommendList.vue?36011f02